/* @sravni/react-design-system version 0.2.65 */
var css = "._hnr2l3 {\n  display: inline-flex;\n}\n";
var modules_037eb246 = {"container":"_hnr2l3"};
import "../../../assets/components/CountDown/src/CountDown-d0e62ee7.css";

export default modules_037eb246;
export { css };
